import { LABEL_CATEGORY, type LabelCategory } from '@vagusx/shared';

/**
 * Canonical user-facing names for each label category. Internal enum values
 * (`document_type`, `workflow_tag`, `procedural`) are storage details — the
 * UI always shows the friendly label.
 */
export const CATEGORY_OPTIONS: {
  value: LabelCategory;
  label: string;
  help: string;
}[] = [
  {
    value: LABEL_CATEGORY.DOCUMENT_TYPE,
    label: 'Document Type',
    help: 'Describes what the document is (referral, prescription, …). Only one per attachment.',
  },
  {
    value: LABEL_CATEGORY.WORKFLOW_TAG,
    label: 'Workflow',
    help: 'Routing or escalation signal (urgent, physician review, …). Multiple allowed.',
  },
  {
    value: LABEL_CATEGORY.PROCEDURAL,
    label: 'Procedural',
    help: 'Pipeline-managed (voicemail, …). Rare for custom labels — use only if the label is set automatically.',
  },
];

export const CATEGORY_VALUES: readonly LabelCategory[] = CATEGORY_OPTIONS.map((o) => o.value);

/** Map a category enum value to its user-facing label. Returns the raw value
 * if unknown so legacy/forward-compat data still renders. */
export function categoryLabel(value: string | null | undefined): string {
  if (!value) return '';
  return CATEGORY_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

export function coerceCategory(value: string | null | undefined): LabelCategory {
  return CATEGORY_VALUES.includes(value as LabelCategory)
    ? (value as LabelCategory)
    : LABEL_CATEGORY.WORKFLOW_TAG;
}
